import Chart from 'chart.js/auto';
import 'chartjs-adapter-moment';

const ledgerDashboardGraphs = (lazyLoadedElement) => {
  const { tab } = lazyLoadedElement.dataset;

  const transactionGroupsChart = document.getElementById('transaction-groups-chart');
  const transactionGroupsDataDiv = document.getElementById('transaction-groups-data');
  if (transactionGroupsDataDiv) {
    if (!Chart.getChart(transactionGroupsChart)) {
      const transactionGroupsData = JSON.parse(transactionGroupsDataDiv.dataset.attrs);
      const transactionGroupsPie = new Chart(transactionGroupsChart, {
        type: 'pie',
        data: transactionGroupsData,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              top: 0,
              right: 20,
              bottom: 20,
              left: 20,
            },
          },
          plugins: {
            legend: {
              position: 'top',
            },
            title: {
              display: true,
              text: 'Ledger transaction groups by type',
              font: {
                size: 18,
              },
            },
          },
        },
      });
    }
  }

  const transactionsChart = document.getElementById('transactions-chart');
  const transactionsDataDiv = document.getElementById('transactions-data');
  if (transactionsDataDiv) {
    if (!Chart.getChart(transactionsChart)) {
      const transactionsData = JSON.parse(transactionsDataDiv.dataset.attrs);
      const transactionsBar = new Chart(transactionsChart, {
        type: 'bar',
        data: transactionsData,
        options: {
          indexAxis: 'y', // This makes it a horizontal bar chart
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: {
              beginAtZero: true,
              ticks: {
                stepSize: 1,
                precision: 0,
              },
              title: {
                display: true,
                text: 'Number of Transactions',
                font: {
                  size: 16,
                },
              },
            },
            y: {
              ticks: {
                autoSkip: false,
              },
            },
          },
          plugins: {
            legend: {
              display: false,
            },
            title: {
              display: true,
              text: 'Ledger transactions by type',
              font: {
                size: 18,
              },
            },
          },
        },
      });
    }
  }
};

export default ledgerDashboardGraphs;